/**
 * @file downloadLanguages.ts
 *
 * @description Languages offered when downloading reports and transcripts.
 */
export const SUPPORTED_REPORT_DOWNLOAD_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Spanish" },
  { code: "hi", label: "Hindi" },
  { code: "vi", label: "Vietnamese" },
] as const;

// Codes must match what the translation backend expects. Two non-obvious
// ones: Mandarin is "zh"/"zh-TW" (not "cmn"/"man") and Tagalog is "tl".
export const SUPPORTED_TRANSCRIPT_DOWNLOAD_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Spanish" },
  { code: "zh", label: "Mandarin (Simplified)" },
  { code: "zh-TW", label: "Mandarin (Traditional)" },
  { code: "fa", label: "Farsi" },
  { code: "it", label: "Italian" },
  { code: "fr", label: "French" },
  { code: "ru", label: "Russian" },
  { code: "pa", label: "Punjabi" },
  { code: "tl", label: "Tagalog" },
  { code: "vi", label: "Vietnamese" },
  { code: "ko", label: "Korean" },
  { code: "ar", label: "Arabic" },
] as const;

export const DEFAULT_DOWNLOAD_LANGUAGE = "en";
